// extracted by mini-css-extract-plugin
module.exports = {"colorSecond":"#c0d1cf"};